import ApplicationLayout from '../../../components/layouts/ApplicationLayout';

const GameInfoPage = () => {
  return <ApplicationLayout></ApplicationLayout>;
};

export default GameInfoPage;
